document.addEventListener("DOMContentLoaded", () => {
    const pressContainers = document.querySelectorAll('.blogs__container');
    const btnShowMore = document.getElementById('show-more__btn');
    const btnTabs = document.querySelectorAll('.blog-tabs__btn');
    const limit = window.defaultLimit;

    function loadFilteredCases(product, limit) {
        const container_grid = $('#blog_grid')
        $.ajax({
            type: 'GET',
            url: `${location.pathname}?limit=${limit}`,
            data: {filter: product},
            success: function (data) {
                container_grid.replaceWith(data.items_html);
                if (btnShowMore) {
                    if (!data.has_next) {
                        btnShowMore.classList.add('blog__button-more--none')
                        btnShowMore.setAttribute('disabled', "true")
                    } else {
                        btnShowMore.removeAttribute('disabled')
                        btnShowMore.classList.remove('blog__button-more--none')
                    }
                }
            },
            error: function () {
            },
        })
    }


    $("#show-more__btn").on("click", function (e) {
        e.preventDefault()
        var selectedProduct = $(".blog-tabs__btn.active").attr("data-id");
        if (btnTabs.length && selectedProduct === undefined) {
            selectedProduct = btnTabs[0].getAttribute("data-id");
        }
        if (!window.productLimits) {
            window.productLimits = {}
        }
        if (!selectedProduct) {
            if (!window.productLimits["recommended"]) {
                window.productLimits["recommended"] = limit;
            }
            window.productLimits["recommended"] += limit;
            loadFilteredCases("recommended", window.productLimits["recommended"]);
        }
        if (selectedProduct) {
            if (!window.productLimits[selectedProduct]) {
                window.productLimits[selectedProduct] = limit;
            }
            window.productLimits[selectedProduct] += limit;
            loadFilteredCases(selectedProduct, window.productLimits[selectedProduct]);
        } else {
            console.error("Product not selected")
        }
    })

    pressContainers[0]?.classList.add('active');
    btnTabs[0]?.classList.add('active');
    if (btnTabs.length) {
        // getLimit(mediaMobile);
        loadFilteredCases(btnTabs[0]?.getAttribute("data-id"), limit);
    }

    $('.blog-tabs__btn').on("click", function (event) {
        event.stopImmediatePropagation();
        $('.blog-tabs__btn').removeClass("active")
        $(this).addClass("active")
        var selectedProduct = $(this).attr("data-id");
        loadFilteredCases(selectedProduct, limit);
    });

    $(".js-press-show").on("click", (e) => {
        btnShowMore.classList.add("active");
        pressContainers.forEach(container => {
            if (container?.classList.contains('active')) {
                container?.classList.add('active--mobile');
            }
        })
    });

    // menu anchors headers links logic
    let nav_links = document.querySelectorAll(".menu__anchors-link");
    let header = document.querySelector(".header");
    let nav_block = document.querySelector(".menu__anchors");

    function getCoords(el, parent) {
        const parentPos = parent.getBoundingClientRect();
        const childPos = el.getBoundingClientRect();
        const relativePos = {};

        relativePos.top = childPos.top - parentPos.top,
            relativePos.right = childPos.right - parentPos.right,
            relativePos.bottom = childPos.bottom - parentPos.bottom,
            relativePos.left = childPos.left - parentPos.left;

        return relativePos;
    }

    function getCoordsfromPage(elem) {
        let box = elem.getBoundingClientRect();
      
        return {
          top: box.top + window.scrollY,
          right: box.right + window.scrollX,
          bottom: box.bottom + window.scrollY,
          left: box.left + window.scrollX
        };
      }

    for (let nav_link of nav_links) {
        nav_link.addEventListener("click", (e) => {
            e.preventDefault();
                let selector = e.target.getAttribute("href").replace("\!", "\\!").replace("\(", "\\(").replace("\)", "\\)").replace("\*", "\\*");

                let scrollEl = document.querySelector(selector);
                window.scroll(0, scrollEl.offsetTop - header.offsetHeight + 1);
        });
    }

    window.addEventListener("scroll", () => {
        let i = nav_links.length - 1;

        for (let nav_link of nav_links) {
            nav_link.classList.remove("active");
        }

        for (i; i >= 0; i--) {
            try {
                let selector = nav_links[i].getAttribute("href").replace("\!", "\\!").replace("\(", "\\(").replace("\)", "\\)").replace("\*", "\\*");

                let scrollEl = document.querySelector(selector);
                if (window.scrollY > (scrollEl.offsetTop - header.offsetHeight)) {
                    nav_links[i].classList.add("active");

                    let cordsDiff = getCoords(nav_links[i], nav_block).top;

                    if (cordsDiff - nav_block.scrollTop + 18 > 300 || cordsDiff < 0) {
                        nav_block.scrollTop = getCoords(nav_links[i], nav_block).top;
                    }

                    break;
                }
            } catch (error) {
                console.log(error)
            }
        }
    });

    window.addEventListener('mousemove', function (ev) {
        let blog_cards = document.querySelectorAll(".blog__card__author");

        let not_author = true;
        for (let blog_card_author of blog_cards) {
            if (ev.target == blog_card_author) {
                not_author = false;
                blog_card_author.classList.add("active");

                let X = 0,
                Y = 0;

                let ev = window.event || ev;
                X=ev.pageX;
                Y=ev.pageY;

                let el = blog_card_author.querySelector('.blog__card__author_hint');
                let cords = getCoordsfromPage(blog_card_author);
                let cardX = cords.left;
                let cardY = cords.top;
                let p = 'px';
                el.style.left = X - cardX - 10 + p;
                el.style.top = Y - cardY + 25 + p;
            }
        }
        
        if (not_author) {
            for (let blog_card_author of blog_cards) {
                blog_card_author.classList.remove("active");
            }
        }
    });
});